import { render, staticRenderFns } from "./manuSpectaculars.vue?vue&type=template&id=03eafeab&scoped=true&"
import script from "./manuSpectaculars.vue?vue&type=script&lang=js&"
export * from "./manuSpectaculars.vue?vue&type=script&lang=js&"
import style0 from "./manuSpectaculars.vue?vue&type=style&index=0&id=03eafeab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03eafeab",
  null
  
)

export default component.exports